import React from "react";
import { Users, Gift, TrendingUp, ChevronRight, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useThemeHook from "../hooks/useThemeHook";
import { PAGE_NAME } from "../../types";

const ViralPromoCard: React.FC = () => {
  const theme = useThemeHook();
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate(PAGE_NAME.INVITE_USERS)}
      className={`p-1 rounded-3xl bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 cursor-pointer shadow-lg shadow-purple-500/20 active:scale-[0.98] transition-all`}
    >
      <div className={`relative p-5 rounded-[22px] overflow-hidden ${
        theme === "dark" ? "bg-slate-900" : "bg-white"
      }`}>
        {/* Background Effects */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-purple-500/10 rounded-full blur-3xl -mr-10 -mt-10" />
        
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="bg-purple-100 dark:bg-purple-900/50 p-2 rounded-xl">
              <Users size={18} className="text-purple-600 dark:text-purple-400" />
            </div>
            <span className="text-xs font-black uppercase tracking-wider text-purple-600 dark:text-purple-400">
              New Rewards
            </span>
          </div>
          <span className="flex items-center text-[10px] font-bold text-slate-400 bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded-full">
            Limited Time <Zap size={10} className="ml-1 fill-amber-500 text-amber-500" />
          </span>
        </div>

        <h3 className={`text-lg font-black leading-tight mb-1 ${theme === "dark" ? "text-white" : "text-slate-900"}`}>
          Build Your Squad, <br/>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-pink-500">
            Earn Forever.
          </span>
        </h3>
        
        <p className="text-xs font-medium text-slate-500 dark:text-slate-400 mb-4 leading-relaxed">
          Get <span className="text-slate-900 dark:text-white font-bold">200 ATH</span> per invite + <span className="text-slate-900 dark:text-white font-bold">10% commission</span> on their mining!
        </p>

        <div className="flex items-center gap-2">
          <div className="flex -space-x-2">
             <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-[10px] font-bold border-2 border-white dark:border-slate-900">10%</div>
             <div className="w-8 h-8 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold border-2 border-white dark:border-slate-900">5%</div>
             <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center text-white text-[10px] font-bold border-2 border-white dark:border-slate-900">
               <Gift size={12} />
             </div>
          </div>
          <div className="flex-1 bg-slate-100 dark:bg-slate-800 rounded-xl py-2 px-3 flex items-center justify-between group">
            <span className="text-[10px] font-bold text-slate-600 dark:text-slate-300">Start Earning</span>
            <ChevronRight size={14} className="text-slate-400 group-hover:translate-x-1 transition-transform" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViralPromoCard;
